import { render, staticRenderFns } from "./showAttchment.vue?vue&type=template&id=2320c169&lang=pug"
import script from "./showAttchment.vue?vue&type=script&lang=js"
export * from "./showAttchment.vue?vue&type=script&lang=js"
import style0 from "./showAttchment.vue?vue&type=style&index=0&id=2320c169&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports